module.exports = __webpack_public_path__ + "img/link_drtel.0cacf5c1.jpg";